import React          from 'react';
import VerticalSlider from './vertical-slider';


export default class DrawerScrubber extends VerticalSlider {
    render(){
        let thumbStyle = {
            top: `${this.props.pct}%`
        }
        return (
            <div className="drawer-scrubber-container">
              <div ref="line"
                   className="drawer-scrubber-line"></div>
              <div ref="thumb"
                   className="drawer-scrubber-thumb-wrapper"
                   style={thumbStyle}>
                <div ref="thumbImage"
                     onMouseDown={this.mouseDown}
                     onTouchStart={this.touchStart}
                     className="drawer-scrubber-thumb"></div>
              </div>
            </div>
        );
    }
}
